export default {
  "menu.welcome": "欢迎",
  "menu.more-blocks": "更多区块",
  "menu.home": "首页",
  "menu.admin": "管理页",
  "menu.admin.sub-page": "二级管理页",
  "menu.login": "登录",
  "menu.register": "注册",
  "menu.register-result": "注册结果",
  "menu.dashboard": "Dashboard",
  "menu.dashboard.analysis": "分析页",
  "menu.dashboard.monitor": "监控页",
  "menu.dashboard.workplace": "工作台",
  "menu.exception.403": "403",
  "menu.exception.404": "404",
  "menu.exception.500": "500",
  "menu.form": "表单页",
  "menu.form.basic-form": "基础表单",
  "menu.form.step-form": "分步表单",
  "menu.form.step-form.info": "分步表单（填写转账信息）",
  "menu.form.step-form.confirm": "分步表单（确认转账信息）",
  "menu.form.step-form.result": "分步表单（完成）",
  "menu.form.advanced-form": "高级表单",
  "menu.list": "列表页",
  "menu.list.table-list": "查询表格",
  "menu.list.basic-list": "标准列表",
  "menu.list.card-list": "卡片列表",
  "menu.list.search-list": "搜索列表",
  "menu.list.search-list.articles": "搜索列表（文章）",
  "menu.list.search-list.projects": "搜索列表（项目）",
  "menu.list.search-list.applications": "搜索列表（应用）",
  "menu.profile": "详情页",
  "menu.profile.basic": "基础详情页",
  "menu.profile.advanced": "高级详情页",
  "menu.result": "结果页",
  "menu.result.success": "成功页",
  "menu.result.fail": "失败页",
  "menu.exception": "异常页",
  "menu.exception.not-permission": "403",
  "menu.exception.not-find": "404",
  "menu.exception.server-error": "500",
  "menu.exception.trigger": "触发错误",
  "menu.account": "个人页",
  "menu.account.center": "个人中心",
  "menu.account.settings": "个人设置",
  "menu.account.trigger": "触发报错",
  "menu.account.logout": "退出登录",
  "menu.editor": "图形编辑器",
  "menu.editor.flow": "流程编辑器",
  "menu.editor.mind": "脑图编辑器",
  "menu.editor.koni": "拓扑编辑器",

  "menu.system": "系统管理",
  "menu.system.menu-anagement": "菜单管理",
  "menu.system.role-management": "角色管理",
  "menu.system.auth-user": "分配用户",
  "menu.system.auth-role": "分配角色",
  "menu.system.user-management": "用户管理",

  // 试卷管理
  "menu.paper-management": "试卷管理",
  "menu.paper-management.paper-list": "试卷列表",
  "menu.paper-management.add-paper": "创建试卷",
  "menu.paper-management.edit-paper": "编辑试卷",
  "menu.paper-management.paper-preview": "试卷预览",

  // 考试管理
  "menu.exam-management": "考试管理",
  "menu.exam-management.exam-list": "考试列表",
  "menu.exam-management.add-exam": "创建考试",
  "menu.exam-management.edit-exam": "编辑考试",
  "menu.exam-management.exam-detail": "考试详情",
  "menu.exam-management.examinees-list": "考生列表",

  // 监考管理
  "menu.invigilate-management": "监考管理",
  "menu.invigilate-management.invigilate-list": "监考列表",
  "menu.invigilate-management.invigilate-detail": "监考详情",
  "menu.invigilate-management.member-list-detail": "考生列表",

  // 我的考试
  "menu.my-exam": "我的考试",
  "menu.my-exam.stu-examList": "考试列表",
  "menu.my-exam.stu-exam-detail": "考试详情",

  // 阅卷管理
  "menu.examiner-management": "阅卷管理",
  "menu.examiner-management.examiner-list": "阅卷列表",
  "menu.examiner-management.examiner-detail": "阅卷详情",
  "menu.examiner-management.examiner-record": "阅卷记录",
  "menu.examiner-management.student-list": "考生列表",
  "menu.examiner-management.grading": "批阅试卷",
};
